import { useMutation } from '@tanstack/react-query'
import type { UseMutationResult } from '@tanstack/react-query'
import { COMMUNITY_SECURE_GLOBAL_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { communityKeys } from './key-factory'

interface AcceptInvitationBody {
  invitationToken: string
  confirmationToken?: string
}

interface UseAcceptInvitationOptions {
  communityPath: string
}

export const useAcceptInvitation = ({
  communityPath,
}: UseAcceptInvitationOptions): UseMutationResult<void, Error, AcceptInvitationBody> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.post, void>({
    method: RequestMethodsEnum.post,
    unauthorizedResponseHandler: () => {},
  })

  return useMutation({
    mutationKey: communityKeys.invitations.accept(communityPath),
    mutationFn: async (body: AcceptInvitationBody) =>
      fetcher(`${COMMUNITY_SECURE_GLOBAL_PREFIX}/${communityPath}/accept-invitation`, body),
    retry: false,
  })
}
